import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  AccountUpdatePasswordMutation,
  AccountUpdatePasswordMutationVariables,
} from '@gql/graphql';
import { useCallback } from 'react';
import { useCurrentAccount } from '..';

export const ACCOUNT_UPDATE_PASSWORD = graphql(`
  mutation AccountUpdatePassword($password: String!) {
    updatePassword(password: $password) {
      token
      account {
        ...CurrentAccountInfo
      }
    }
  }
`);

export const useUpdatePassword = () => {
  const { currentAccountUpdateCache } = useCurrentAccount();
  const [updatePasswordMutation, { loading, error }] = useMutation<
    AccountUpdatePasswordMutation,
    AccountUpdatePasswordMutationVariables
  >(ACCOUNT_UPDATE_PASSWORD);

  const updatePassword = useCallback(
    async (password: string) => {
      const data = await updatePasswordMutation({
        variables: {
          password,
        },
      });

      currentAccountUpdateCache(
        data?.data?.updatePassword?.account,
        data?.data?.updatePassword?.token,
      );
    },
    [currentAccountUpdateCache, updatePasswordMutation],
  );

  return { updatePassword, updatePasswordLoading: loading, updatePasswordError: error };
};
